// All constants and static data for the Landing feature
// See ARCHITECTURE_GUIDE.md for rules

// Demo user email for landing demo
export const DEMO_USER_EMAIL = 'balansag.reylester.4.17.18@gmail.com';

// Feature list for the landing page
export const FEATURE_LIST = [
  {
    title: 'People-to-People Chat',
    description:
      'Connect your customers directly with your team through real-time messaging. Enable personalized conversations that build trust and loyalty.',
    icon: '💬',
  },
  {
    title: 'Chat Journey Builder',
    description:
      'Design customized conversation flows that guide customers through their journey. Create interactive experiences that convert visitors into loyal customers.',
    icon: '🧱',
  },
  {
    title: 'QR Powered',
    description:
      'Generate QR codes that customers can scan to instantly open a chat box. Customers can also view your shop description and location information through the same QR code.',
    icon: '🤳',
  },
];

// Static testimonials array (empty by default)
export const TESTIMONIALS = [];

// About section cards
export const ABOUT_CARDS = [
  {
    icon: 'pi pi-briefcase',
    title: 'Personal Service Showcasing',
    description:
      "Highlight your services or products in a personalized way. Whether you're a freelancer, consultant, or small business owner, use YesBoss to engage with your customers directly. Share your expertise or demonstrate your offerings in real-time with seamless messaging.",
  },
  {
    icon: 'pi pi-users',
    title: 'Local Store Assistance',
    description:
      "No one in-store? No problem! Even if you’re busy running errands or tied up at home, YesBoss ensures your customers can still reach out for assistance. Whether they need help finding a product or asking about promotions, your store will never be out of touch.",
  },
  {
    icon: 'pi pi-sort-alt-slash',
    title: 'Front Desk Replacement',
    description:
      "Transform your front desk into a digital assistant. YesBoss can handle customer inquiries, appointment bookings, and provide instant answers—perfect for businesses that need an efficient, automated front-desk solution without the overhead.",
  },
  {
    icon: 'pi pi-users',
    title: 'General Inquiry Handling (Like a Call Center)',
    description:
      "Whether you're a startup or an established company, manage customer inquiries with ease. YesBoss provides a simple and reliable communication channel for questions, feedback, and support, just like a traditional call center, but with a modern touch.",
  },
];

// Brand name (from environment or fallback)
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'Yes Boss';
